module.exports = "<!-- BREADCRUMB -->\n<div class=\"boo-breadcrumb\">\n\t<div class=\"container\">\n\t\t<ol class=\"breadcrumb\">\n\t\t\t<li *ngFor=\"let breadcrumb of breadcrumbs$ | async; let isLast = last\" class=\"active\" [class.active]=\"isLast\">\n\t\t\t\t<a *ngIf=\"!isLast\" [routerLink]=\"[breadcrumb.url]\">\n\t\t\t\t\t{{ breadcrumb.label }}\n\t\t\t\t</a>\n\t\t\t\t<span *ngIf=\"isLast\">{{ breadcrumb.label }}</span>\n\t\t\t</li>\n\t\t</ol>\n\t</div>\n</div>\n<!-- END // BREADCRUMB -->"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/ui/breadcrumbs/breadcrumbs.component.html
// module id = ./src/app/components/ui/breadcrumbs/breadcrumbs.component.html
// module chunks = main